import Api from './ApiRequest';

export default {
    getAll: (params) => Api.get('/cent/email/templates', params),
    getById: (id) => Api.get('/cent/email/template/' + id, null),
    getByType: (typeId) => Api.get('/cent/email/templates/type/' + typeId, null),
    save: (entity) => Api.post('/cent/email/template', entity),
    update: (id, entity) => Api.put('/cent/email/template/' + id, entity),
    delete: (id) => Api.delete('/cent/email/template/' + id),
    search: (searchText) => Api.get('/cent/email/templates/search', {q: searchText}),
    getTypes: (params = null) => Api.get('/cent/email/template/types', params),
};